import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHCampaignParticipantCache extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  static modelName = 'BHCampaignParticipantCache'
  static instanceDefaults() {
    return {
      campaign_id: null,
      trend_period: 1,
      participant_data: null,
      total_count: 0,
      calculated_count: 0,
      is_complete: false,
      calculated_at: null
    }
  }
}

const servicePath = 'bh-campaign-participant-cache';
const servicePlugin = makeServicePlugin({
  Model: BHCampaignParticipantCache,
  service: feathersClient.service(servicePath),
  servicePath
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
